import type { JSX } from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type { IListProps } from 'blocks/List'
import type { FIXED_INDENTS } from 'vars/index'

import { List } from 'blocks/List'
import { INDENTS } from 'vars/index'

export interface ILabelGroupProps {
  children?: IListProps['children']
  divider?: IListProps['divider']
  width?: IListProps['width']
  direction?: IListProps['direction']
  justifyContent?: IListProps['justifyContent']
  wrap?: IListProps['wrap']
  columnGap?: IListProps['columnGap']
  rowGap?: IListProps['rowGap']
  color?: TextBoxColors
  paddings?: FIXED_INDENTS[]
  alignItems?: IListProps['alignItems']
  margins?: IListProps['margins']
  quality?: string
  dolbyAtmos?: boolean
}

export const LabelGroup = ({
  children,
  divider,
  width,
  direction,
  justifyContent,
  wrap,
  columnGap = INDENTS.INDENT_10,
  rowGap = INDENTS.INDENT_30,
  color,
  paddings,
  alignItems,
  margins,
}: ILabelGroupProps): JSX.Element => (
  <List
    width={width}
    direction={direction}
    justifyContent={justifyContent}
    wrap={wrap}
    divider={divider}
    columnGap={columnGap}
    rowGap={rowGap}
    color={color}
    paddings={paddings}
    alignItems={alignItems}
    margins={margins}
  >
    {children}
  </List>
)
